import { jsx as _jsx } from "react/jsx-runtime";
import { CatPagination } from '@blocks-react/components/Pagination';
import styles from '../NotificationDrawer.module.scss';
export const NotificationCatPagination = ({ pageSize, handlePageChange, totalRecords, currentPage, className = 'mt-4' }) => {
    return (_jsx(CatPagination, { totalRecords: totalRecords, pageSize: pageSize, onBlPageChange: handlePageChange, currentItem: currentPage, "data-testid": "Notification-Pagination", className: `${className} ${styles['notification-footer--pagination']}`, hidePageSize: true, variant: "in-page" }));
};
